import { render, staticRenderFns } from "./WhichClub.vue?vue&type=template&id=d06d71de&"
import script from "./WhichClub.vue?vue&type=script&lang=ts&"
export * from "./WhichClub.vue?vue&type=script&lang=ts&"
import style0 from "./WhichClub.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports